module.exports = __webpack_public_path__ + "static/media/Logo4.3de0e13e.png";